import { AppBar, Button, Card, Paper, styled, Tab } from "@mui/material";

export const StyledAppBar = styled(AppBar)(({ theme }) => ({
  backgroundColor: "white",
  boxShadow: "none",
  borderBottom: "1px solid #e0e0e0",
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#1976d2",
  color: "white",
  borderRadius: "20px",
  padding: "8px 20px",
  minWidth: "250px",
  maxWidth: "500px",
  width: "100%",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  "&:hover": {
    backgroundColor: "#1565c0",
  },
  fontSize: "18px",
  [theme.breakpoints.down('md')]: {
    fontSize: "16px",
    padding: "6px 16px",
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: "14px",
    padding: "4px 12px",
  }
}));

export const StyledTab = styled(Tab)(({ selected, theme }) => ({
  padding: '8px 16px',
  border: '1px solid #ccc',
  borderRadius: '8px',
  margin: '0 4px',
  cursor: 'pointer',
  backgroundColor: selected ? '#f0f0f0' : '#fff',
  fontWeight: selected ? 800 : 600,
  transition: 'all 0.3s',
  color: "black"
}));

export const MetricCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1.5),
  textAlign: "center",
  height: "120px", // fixed height for all cards
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  overflow: "hidden",
  wordWrap: "break-word",
  color: "black"
}));


export const ChartCard = styled(Card)(({ theme }) => ({
  height: "100%",
  boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.08)",
  borderRadius: "8px",
}));
